export const BASE_API_URL = 'https://pixabay.com/api/';
export const API_KEY = '38261865-acd13161795bdb5e93290869b';
